import React from 'react';
import Logo from '../../../assets/images/PureSocial.svg';
import { Link } from 'react-router-dom';

export default function Mainbanner(props) {
    const { location, setReloadCategories } = props;

    const handleRefreshCategories = () => {
        setReloadCategories(true);
    }

    return (
        <>
            <nav className="navbar navbar-expand navbar bg-white border-bottom flex-column flex-md-row bd-navbar">
                <Link to={"/"} onClick={handleRefreshCategories}><img src={Logo} width="120" className="" alt="" /> </Link>
        
                <ul className="navbar-nav flex-row ml-md-auto d-md-flex">
                    <li className="nav-item">
                        <Link 
                            to={"/"} 
                            className={ location.pathname === "/" ? "nav-link active" : "nav-link"}
                            onClick={handleRefreshCategories}
                        >
                            Home
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link 
                            to={"/releasenotes"} 
                            className={ location.pathname === "/releasenotes" ? "nav-link active" : "nav-link"}
                            onClick={handleRefreshCategories}
                        >
                            Release Notes
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link 
                            target={"_blank"} 
                            to={"/support"} 
                            className={ location.pathname === "/support" ? "nav-link active" : "nav-link"}
                        >
                            Support
                        </Link>
                    </li>
                </ul>
            </nav>
        </>
    )
}
